import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFilter',
})
export class DateFilterPipe implements PipeTransform {
  transform(
    items: any[],
    dateField: string,
    minDate: Date,
    maxDate: Date
  ): any[] {
    let filteredItems = items.filter((el) => {
      if (!(el[dateField] instanceof Date)) return true;
      return evaluate(el[dateField], minDate, maxDate);
    });

    return filteredItems;
  }
}

function evaluate(val: Date, min?: Date, max?: Date) {
  if (min && val < min) return false;
  else if (max && val > max) return false;
  else return true;
}
